import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'kwo-featured-image',
	templateUrl: './featured-image.component.html',
	styleUrls: ['./featured-image.component.scss'],
	standalone: true,
	imports: [CommonModule],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeaturedImageComponent implements OnInit {

	@Input() image: string;
	@Input() cover: string;

	constructor() { }

	ngOnInit(): void {
	}

}
